import React from "react";
import LocationImg from "../../assets/images/locationImg.jpeg";
import { Box, Typography } from "@mui/material";

const LocationPage = () => {
  return (
    <Box sx={{ margin: "50px 250px" }}>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "25px",
          fontWeight: "600",
          lineHeight: "35px",
        }}
      >
        Dear User This Photo capture process requires the user to be within
        India.Since the location captured is outside of India. We cannot process
        this request.
      </Typography>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <img
          src={LocationImg}
          alt="Location Illustration"
          style={{
            maxWidth: "100%",
            height: "400px",
            objectFit: "contain",
          }}
        />
      </div>
    </Box>
  );
};

export default LocationPage;
